export default __webpack_public_path__ + "static/media/ic_contactar_laboratorio_home_pro.b43a772e.svg";